module.exports = __webpack_public_path__ + "img/sun.825e9cf7.png";